module.exports = __webpack_public_path__ + "img/B918.02c42fd0.jpg";